<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleExport" plain :loading="exportLoading">导出</el-button>
          <el-button size="mini" @click="handleBack" >返回上一页</el-button>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column label="直播间" prop="liveName" align="center" />
        <el-table-column label="直播类型" prop="liveType" align="center">
          <!-- <template slot-scope="{row}">
            {{ getLiveTypeText(row.liveType) }}
          </template> -->
        </el-table-column>
        <el-table-column label="主播名称" prop="anchorName" align="center" />
        <el-table-column label="主播手机号" prop="anchorPho" align="center" />
        <el-table-column label="主播身份" prop="anchorPositionName" align="center" />
        <el-table-column label="进入直播间次数" prop="joinCount" align="center" />
        <el-table-column label="最后进入直播间时间" prop="lastJoinTime" align="center" />
        <el-table-column label="观看直播时长" prop="lookTimeSpan" align="center" />
        <!-- <el-table-column label="参与福袋次数" prop="luckyBagCount" align="center" >
          <template slot-scope="{row}" > 
            <el-link type="primary" :underline="false" @click="handleLuckyBag(row)">{{ row.luckyBagCount || 0 }}</el-link>
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="中奖次数" prop="winCount" align="center" >
          <template slot-scope="{row}"> 
            <el-link type="primary" :underline="false" @click="handleWin(row)">{{ row.winCount || 0 }}</el-link>
          </template>
        </el-table-column> -->
        <el-table-column label="下单量" prop="orderCount" align="center" >
          <template slot-scope="{row}"> 
            <el-link type="primary" :underline="false" @click="handleOrder(row)">{{ (row.seckillOrderCount || 0) + (row.balanceOrderCount || 0) }}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="充值次数" prop="rechargeCount" align="center" >
          <template slot-scope="{row}"> 
            <el-link type="primary" :underline="false" @click="handleRecharge(row)">{{ row.rechargeCount || 0 }}</el-link>
          </template>
        </el-table-column>
        <!-- <el-table-column label="打赏主播" prop="tipAmount" align="center" >
          <template slot-scope="{row}"> 
            <el-link type="primary" :underline="false" @click="handleTip(row)">{{ row.tipAmount || 0 }}</el-link>
          </template>
        </el-table-column> -->
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <LuckyBag ref="luckyBag" />
  </div>
</template>

<script>
import liveManageApi from '@/api/live/liveManage'
import Pagination from '@/components/Pagination'
import LuckyBag from './luckyBag.vue'
export default {
  components: {
    Pagination,
    LuckyBag
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      exportLoading: false,
      userId: null, // 用户ID
      query: {
        pageNo: 1,
        pageSize: 10,
        userId: 0
      },
      selectItems: []
    }
  },
  created() {
    // 从路由参数获取userId
    if (this.$route.query.userId) {
      this.userId = parseInt(this.$route.query.userId)
      this.query.userId = this.userId
    }
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    handleExport() {
      // 先请求导出接口获取任务code，然后跳转到导出页面
      this.exportLoading = true
      
      // 准备导出参数
      const exportParams = {
        userId: this.userId || 0
      }
      
      console.log('导出参数:', exportParams)
      
      // 先请求导出接口创建任务
      liveManageApi.downloadStatisticsByUserDetail(exportParams)
        .then(response => {
          console.log('导出任务创建响应:', response)
          if (response.data && response.data.code) {
            // 获取任务code，跳转到导出页面
            this.$router.push({
              path: '/export/list',
              query: {
                code: response.data.code
              }
            })
            this.$message.success('导出任务已创建，正在跳转到下载页面')
          } else {
            this.$message.error('导出失败：未获取到任务代码')
          }
        })
        .catch(error => {
          console.error('导出任务创建失败:', error)
          this.$message.error('导出任务创建失败：' + (error.message || '未知错误'))
        })
        .finally(() => {
          this.exportLoading = false
        })
    },
    handleLuckyBag(row) {
      this.$refs.luckyBag.handleShow(row)
    },
    handleBack() {
      // 返回上一页
      this.$router.go(-1)
    },
    getLiveTypeText(liveType) {
      const liveTypeMap = {
        1: '竖屏带货直播',
        2: '横屏培训直播'
      }
      return liveTypeMap[liveType] || '未知'
    },
    handleFilter() {
      this.query = {}
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      
      // 确保userId参数正确传递
      if (this.userId) {
        this.query.userId = this.userId
      }
      
      this.listLoading = true
      return liveManageApi.fetchLiveStatisticsByUserDetail(this.query)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => sysGoodsCategorizeApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => sysGoodsCategorizeApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    beforeHandleCommand(row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    handleCommand(command) {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择')
        return
      }
      let ids = this.selectItems.map(row => row.id)
      let txt = ""
      if (command.command === 1) {
        this.handleBatchState(ids, 1)
      } else if (command.command === 2) {
        this.handleBatchState(ids, 0)
      }
    },
    handleBatchState(ids, type) {
      let txt = type === 1 ? '确认将选中批量启用？' : '确认将选中批量禁用？'
      this.$common.confirm(txt).then(() => sysGoodsCategorizeApi.setIsEnableBatch({ ids: ids, isEnable: type ? true : false }))
        .then(() => {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    changeSwitch(row) {
      sysGoodsCategorizeApi.setIsEnable({ id: row.id, isEnable: row.isEnable }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.$refs.liveAdd.handleCreate(row)
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$emit('handleShow', row, 2)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.liveAdd.handleUpdate(row)
    }
  }
}
</script>
